export default __webpack_public_path__ + "static/media/bci-5.b7294669.svg";